<template>
	<div class="contain">
		<!-- <el-scrollbar style="height:100%;"> -->
			<el-row>
				<el-col :span="24" class="bold-head">获取token</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(1)接口说明 : </span>获取调用接口所需的token</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(2)请求方式 :</span> post</el-col>
			</el-row>
			<el-row>
				<el-col :span="24"><span class="bold">(3)Url :</span> http://121.46.26.109:8060/api/getToken </el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold">输入参数</el-col>
			</el-row>
			<el-table :data="tableOne" border style="width: 100%" class="table-contain">
				<el-table-column prop="name" label="参数名">
				</el-table-column>
				<el-table-column prop="shuoming" label="说明">
				</el-table-column>
				<el-table-column prop="type" label="类型">
				</el-table-column>
				<el-table-column prop="fanwei" label="取值范围">
				</el-table-column>
				<el-table-column prop="pos" label="参数位置">
				</el-table-column>
				<el-table-column prop="select" label="是否必选">
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="24" class="bold ">返回参数</el-col>
			</el-row>
			<el-table :data="tableTwo" border style="width: 100%;" class="table-contain">
				<el-table-column prop="name" label="参数名">
				</el-table-column>
				<el-table-column prop="shuoming" label="说明">
				</el-table-column>
				<el-table-column prop="type" label="类型">
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="24" class="bold">(4)示例</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="bold table-contain">成功返回</el-col>
			</el-row>
			<div class="contain-bg">
				<el-row>
					<el-col :span="24">
						<el-col :span="24">{</el-col>
						<el-col :span="24">"success": 1,</el-col>
						<el-col :span="24">"data":{</el-col>
						<el-col :span="24">"token":"eyJhbGciOiJIUzI1NiJ9.</el-col>
						<el-col :span="24">eyJ1aWQiOjgsInN1YiI6InVzZXIiLCJhcmVhTmFtZSI6IuWNl-</el-col>
						<el-col :span="24">S6rCIsImV4cCI6MTU3NjI2MjUy</el-col>
						<el-col :span="24">NiwiaWF0IjoxNTc2MjAyMDQ2LCJqdGki</el-col>
						<el-col :span="24">OiIwZDIwZmMxMi03M2JhLTQ3NTktOT</el-col>
						<el-col :span="24">IzNy1hMDk3ODJkZWYwMDMiLCJ1c2VybmFtZSI6I</el-col>
						<el-col :span="24">nRlc3RBcGkifQ.m7--hAscS09DVDXXF-oF"</el-col>
						<el-col :span="24">_ygQTj3CiDUfsAIcK8wU2H0</el-col>
						<el-col :span="24">},</el-col>
						<el-col :span="24">"message": "登录成功"</el-col>
						<el-col :span="24">}</el-col>
					</el-col>
				</el-row>
			</div>
		<!-- </el-scrollbar> -->
	</div>

</template>

<script>
	export default {
		data() {
			return {
				tableOne: [{
					name: 'username',
					shuoming: '账号',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}, {
					name: 'password',
					shuoming: '密码(md5加密)',
					type: 'String',
					fanwei: 'NA',
					pos: 'path',
					select: '必填'
				}],
				tableTwo: [{
					name: 'success',
					shuoming: '是否成功 (1:成功2:失败)',
					type: 'int'

				}, {
					name: 'data',
					shuoming: '数据',
					type: 'String'
				}, {
					name: 'message',
					shuoming: '返回信息',
					type: 'String'
				}]
			}
		}
	}
</script>

<style scoped="scoped">
	

	/* 	.contain {
		width: 98%;
		margin: 0 auto;
		font-size: 16px;
		overflow-y: scroll;
		height: 800px;
		padding: 10px 0 0 20px;
	}
	::-webkit-scrollbar {
		width: 6px;
		
	}
	::-webkit-scrollbar-thumb {
		border-radius: 3px;
		height: 100px;
		background-color: #ccc;
	} */
	.contain {
		background: #fff;
		padding: 20px 30px;
		font-size: 16px;
	}

	.contain .el-row {
		margin-bottom: 10px;
	}


	.contain-bg {
		/* width: 100%; */
		padding: 20px;
		background: #f9f9fa;
	}

	.contain-bg .el-col {
		font-size: 14px;
	}

	.bold {
		font-size: 18px;
		font-weight: bold;
	}

	.table-contain {
		margin: 20px 0;
	}

	.bold-head {
		font-size: 20px;
		font-weight: bold;
		margin-bottom: 20px;
	}
</style>
